import { Vue, Component, Watch, Emit, Inject } from 'vue-property-decorator'
import PdfView from '@/components/pdf-view/pdf-view.vue'
import {
    initialReportsModalFormRangeFilter,
    ReportsModalFormRangeFilterState
} from '@/modules/RegistryModule/views/editCase/modals/reports-modal-form/components/reports-modal-form-range-filter/reports-modal-form-range-filter.model'
import { commonCaseTypeService } from '@/api/services/common/case-type/common-case-type.service'
import { CommonCaseTypeResponse } from '@/api/services/common/case-type/common-case-type.dto'
import { Validator } from 'vee-validate'
import { RangeTypeEnum } from '@/modules/RegistryModule/views/editCase/modals/reports-modal-form/reports-modal.model'

@Component({
    components: {
        PdfView
    }
})
export default class ReportsModalFormRangeFilter extends Vue {
    @Inject() externalValidator!: Validator

    @Emit()
    stateChanged(): ReportsModalFormRangeFilterState {
        return this.state
    }

    @Watch('state', { deep: true })
    onStateChange(): void {
        this.stateChanged()
    }

    state: ReportsModalFormRangeFilterState
    constructor() {
        super()
        this.$validator = this.externalValidator
        this.state = initialReportsModalFormRangeFilter()
    }

    async getCaseTypes(): Promise<CommonCaseTypeResponse[]> {
        const response = await this.$_toCallSecure(commonCaseTypeService.getCaseTypes())
        return response ?? []
    }

    onUpdateStartDate(date: Date): void {
        this.state.startDate = date
        this.$validator.reset({ name: this.$tc('registry.modal.reports.startDate') })
    }

    onUpdateEndDate(date: Date): void {
        this.state.endDate = date
        this.$validator.reset({ name: this.$tc('registry.modal.reports.endDate') })
    }

    initializeState(forceDatesReset: boolean = false): void {
        this.state = initialReportsModalFormRangeFilter()
        if (forceDatesReset) {
            this.state.endDate = null
        }
    }

    get caseNumberValidation(): string {
        return `required|case_number`
    }

    get isDateRangeFilter(): boolean {
        return this.state.rangeType?.id !== RangeTypeEnum.CASE_NUMBER
    }
}
